import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:journeyId|budgetId|expenseId|splitCalculationId|resultId|memberId|payerMemberId|recordedByMemberId|ownerMemberId|creatorMemberId|createdByMemberId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

/** Private Journey split calculation — Planning finance only (Payment / Wallet deferred). */
export const journeySplitApi = {
  calculate: (journeyId, body) => travelClient.post(
    travelEndpoints.journeySplitCalculations(journeyId),
    body,
    snowflakeJson,
  ),
  getLatest: (journeyId) => travelClient.get(
    travelEndpoints.journeySplitCalculation(journeyId),
    snowflakeJson,
  ),
  getMemberBalances: (journeyId) => travelClient.get(
    travelEndpoints.journeySplitMemberBalances(journeyId),
    snowflakeJson,
  ),
  shareBalanceToChat: (journeyId, body = { confirm: true }) => travelClient.post(
    travelEndpoints.journeyBalanceChatShare(journeyId),
    body,
    snowflakeJson,
  ),
};
